import EncountersListComponent from "@/Patient/Components/Common/EncountersListComponent";
import { EncountersFilter } from "@/Patient/Components/EncountersFilter/EncountersFilter";
import { EncountersFilterForDirectEdits } from "@/Patient/Components/EncountersFilter/EncountersFilterForDirectEdits";
import { IPatientMedicalNoteModel } from "@/Patient/Models/UI/MedicalNote/IPatientMedicalNoteModel";
import { IPatientMedicalSummaryModel } from "@/Patient/Models/UI/MedicalSummary/IPatientMedicalSummaryModel";

interface IEncountersSidePanelProps {
    model: IPatientMedicalSummaryModel;
    isReadOnly?: boolean;
    displayPrintButton?: boolean;
    displayOnlyApprovedEncounters?: boolean;
    noteModel: IPatientMedicalNoteModel;
    fromMyleOperation?: number;
    toMyleOperation?: number;
    encounterSearchTermChangedOperation?: number;
    isPatientNoteDisabled?: boolean;
    id?: string;
    fromChange?: (date: Date) => void;
    toChange?: (date: Date) => void;
    onMyNotesFilterChanged?: (checked: boolean) => void;
    onClinicVisitNotesFilterChanged?: (checked: boolean) => void;
    newNote: (e: React.MouseEvent) => void;
    showCriteria: () => void;
    toggleDisplayOnlyUnsigned: () => void;
    onEncounterClick?: (encounterId: string) => void;
    onClickCallbackPrintNotes?: () => void;
    onEncounterSearchTermChanged?: (textOrDate: any) => void;
    onSummaryConfigurationChange?: () => void;
    onNotesConfigurationChange?: () => void;
}

export function EncountersSidePanel(props: IEncountersSidePanelProps): JSX.Element {
    return (
        <div className="fxheight tbc transition full-border left-primary encounter-list-main-container" data-cy="medicalNote-encounters">
            {cacheStore.ClinicSettings.EnableDirectPatientProfileEdits && !props.isReadOnly
                ? (
                    <EncountersFilterForDirectEdits
                        model={props.model}
                        isReadOnly={props.isReadOnly}
                        displayPrintButton={props.displayPrintButton}
                        fromMyleOperation={props.fromMyleOperation}
                        toMyleOperation={props.toMyleOperation}
                        encounterSearchTermChangedOperation={props.toMyleOperation}
                        isPatientNoteDisabled={props.isPatientNoteDisabled}
                        id={props.id}
                        fromChange={props.fromChange}
                        toChange={props.toChange}
                        onMyNotesFilterChanged={props.onMyNotesFilterChanged}
                        onClinicVisitNotesFilterChanged={props.onClinicVisitNotesFilterChanged}
                        newNote={props.newNote}
                        onClickCallbackPrintNotes={props.onClickCallbackPrintNotes}
                        onEncounterSearchTermChanged={props.onEncounterSearchTermChanged}
                        onSummaryConfigurationChange={props.onSummaryConfigurationChange}
                        onNotesConfigurationChange={props.onNotesConfigurationChange}
                    />
                )
                : (
                    <EncountersFilter
                        model={props.model}
                        isReadOnly={props.isReadOnly}
                        displayPrintButton={props.displayPrintButton}
                        fromMyleOperation={props.fromMyleOperation}
                        toMyleOperation={props.toMyleOperation}
                        encounterSearchTermChangedOperation={props.encounterSearchTermChangedOperation}
                        isPatientNoteDisabled={props.isPatientNoteDisabled}
                        id={props.id}
                        fromChange={props.fromChange}
                        toChange={props.toChange}
                        newNote={props.newNote}
                        showCriteria={props.showCriteria}
                        toggleDisplayOnlyUnsigned={props.toggleDisplayOnlyUnsigned}
                        onClickCallbackPrintNotes={props.onClickCallbackPrintNotes}
                        onEncounterSearchTermChanged={props.onEncounterSearchTermChanged}
                    />
                )
            }
            <EncountersListComponent
                summaryModel={props.model}
                noteModel={props.noteModel}
                encounterClickFn={props.onEncounterClick}
                context={this}
                displayOnlyApprovedEncounters={props.displayOnlyApprovedEncounters}
            />
        </div>
    );
}
